// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
import HoverMRRDescription from './HoverMRRDescription'
// JS Imports
import {
   formatFloatAsPercent,
   formatFloatAsCurrencySymbol,
} from '../../../common/helpers.mjs'
// Asset Imports

export default function PayrollProductRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (
      state.user_role != 'Partner' &&
      state.user_role != 'Reseller' &&
      (state.user_view == 'Internal' ||
         state.productPayrollTotalEECount > 0 ||
         state.productPayrollEINCount > 1 ||
         state.hasUSEmployees == true)
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['payroll']['ProductName']} (
               {formatFloatAsCurrencySymbol(
                  state.product_list['payroll']['EmpListPrice'],
                  state.currencyObjectUSD,
               )}
               )
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  value={state.productPayrollTotalEECount}
                  disabled
               />
            </div>
            <div className='col col-bhr-red'>
               {state.productPayrollEINCount === 1
                  ? formatFloatAsPercent(
                       state.productPayrollMonthlyCosts[0]
                          .volumeDiscountedPEPMPercent,
                    )
                  : ''}
            </div>
            <div className='col col-bhr-red'>
               {state.hasUSEmployees == true || state.user_view == 'Internal'
                  ? formatFloatAsPercent(
                       state.productPayrollMonthlyTotalCosts
                          .bundleDiscountedPEPMPercent,
                    )
                  : ''}
            </div>
            <div className='col'>
               {state.productPayrollMonthlyTotalCosts.discountedPEPMCost <=
               state.productPayrollMonthlyTotalCosts.listPEPMCost
                  ? formatFloatAsCurrencySymbol(
                       state.productPayrollMonthlyTotalCosts.discountedPEPMCost,
                       state.currencyObjectUSD,
                    )
                  : ''}
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.productPayrollMonthlyTotalCosts.totalPrice,
                  state.currencyObjectUSD,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <Description
                     className='col col-bhr-blue'
                     title={getString('global.PreviousPlan')}
                     content={
                        <div className='row text-nowrap'>
                           <p className='col'>{getString('global.Quantity')}</p>
                           <p className='col text-end'>
                              {state.accountSnowflake.Billed_Payroll__c}
                           </p>
                        </div>
                     }
                  >
                     <span className='hoverable'>
                        {formatFloatAsCurrencySymbol(
                           state.productPayrollMonthlyTotalCosts
                              .previousTotalPrice,
                           state.currencyObjectUSD,
                        )}
                     </span>
                  </Description>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={
                           state.productPayrollMonthlyTotalCosts.listMRRTotal
                        }
                        previousMRRTotal={
                           state.productPayrollMonthlyTotalCosts
                              .previousMRRTotal
                        }
                        MRRTotal={
                           state.productPayrollMonthlyTotalCosts.MRRTotal
                        }
                        MRRTotalUSD={
                           state.productPayrollMonthlyTotalCosts.MRRTotalUSD
                        }
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className='hoverable'>
                           {formatFloatAsCurrencySymbol(
                              state.productPayrollMonthlyTotalCosts
                                 .totalPriceDifference,
                              state.currencyObjectUSD,
                           )}
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <span className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.productPayrollMonthlyTotalCosts
                              .totalPriceDifference,
                           state.currencyObjectUSD,
                        )}
                     </span>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
